import {Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ContactMessage, LoginUser} from '../../models/models';
import {Translation} from '../../models/translation';
import {LoginService} from '../../services/login.service';
import {UserService} from '../../services/user.service';
import {TranslationService} from '../../services/translation.service';
import {AddressService} from '../../services/address.service';
import {MailService} from '../../services/mail.service';
import {ChangePasswordService} from '../../services/change-password.service';
import {MaintenanceService} from '../../services/maintenance.service';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';
import {sha256} from 'js-sha256';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  styleUrls: ['./login.component.css'],
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  @ViewChild('callDialog') dialogTemplate: TemplateRef<any>;
  @ViewChild('callPasswordDialog') dialogPasswordTemplate: TemplateRef<any>;
  @Output() nameChange = new EventEmitter();
  @ViewChild('ngForm') ngForm: any;

  public newContactMessage = new ContactMessage();
  public translationVersion = environment.translationVersion;
  public translation: Translation = new Translation();
  public username = '';
  public password = '';
  public toast = Swal.mixin({ toast: true, position: 'top-right', timer: 5000, timerProgressBar: true, showConfirmButton: false});
  public email: string;
  public christmas = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private addressService: AddressService,
    private mailService: MailService,
    private translationService: TranslationService,
    private changePasswordService: ChangePasswordService,
    private maintenanceService: MaintenanceService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    if (localStorage.getItem('Translation') === null) {
      this.toast.fire('Downloading language package', '', 'info');
      localStorage.setItem('Language', 'DE');
      this.translationService.getTranslation(localStorage.getItem('Language')).subscribe(response => {
        if (response.Ok) {
          localStorage.setItem('Translation', JSON.stringify(response.Obj));
          this.translation = JSON.parse(localStorage.getItem('Translation'));
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else if (+JSON.parse(localStorage.getItem('Translation')).TranslationVersion !== this.translationVersion) {
      this.toast.fire('Downloading language package', '', 'info');
      this.translationService.getTranslation(localStorage.getItem('Language')).subscribe(response => {
        if (response.Ok) {
          localStorage.setItem('Translation', JSON.stringify(response.Obj));
          this.translation = JSON.parse(localStorage.getItem('Translation'));
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else {
      this.translation = JSON.parse(localStorage.getItem('Translation'));
    }
    this.loginService.checkLoginToken();
    const date = new Date();
    if (date.getMonth() === 11 && date.getDate() <= 25) {
      this.christmas = true;
    }
  }

  login(): void {
    this.maintenanceService.checkMaintenance().subscribe(response1 => {
      if (response1.Ok) {
        if (response1.Obj) {
          this.maintenanceService.getMaintenanceDateTime().subscribe(response2 => {
            if (response2.Ok) {
              sessionStorage.setItem('Maintenance', 'true');
              sessionStorage.setItem('MaintenanceDate', response2.Obj[0]);
              sessionStorage.setItem('MaintenanceTime', response2.Obj[1]);
            } else if (response2.Msg === 'Internal Server Error') { console.log(response2.Ex); }
            sessionStorage.setItem('ForceHideMaintenance', 'false');
            if (response2.Msg) { this.toast.fire({title: response2.Msg, icon: response2.Ok ? 'success' : 'error'}); }
          }, error => {
            this.toast.fire(this.translation.InternalServerError);
            return;
          });
        } else {
          sessionStorage.setItem('Maintenance', 'false');
          sessionStorage.setItem('MaintenanceDate', '');
          sessionStorage.setItem('MaintenanceTime', '');
        }
      } else if (response1.Msg === 'Internal Server Error') { console.log(response1.Ex); }
      if (response1.Msg) { this.toast.fire({title: response1.Msg, icon: response1.Ok ? 'success' : 'error'}); }
    }, error => {
      this.toast.fire(this.translation.InternalServerError);
      return;
    });
    if (!this.username) {
      Swal.fire(this.translation.Error, this.translation.UserNameMustBeFilled, 'error').then(r => r);
      return;
    }
    if (!this.password) {
      Swal.fire(this.translation.Error, this.translation.PasswordMustBeFilled, 'error').then(r => r);
      return;
    }

    this.loginService.login(this.username, sha256(this.password)).subscribe((loginUser: LoginUser) => {
      if (loginUser) {
        sessionStorage.setItem('Token', loginUser.access_token);
        sessionStorage.setItem('ExpireDate', loginUser['.expires']);
        this.userService.getUserById(Number(loginUser.Id)).subscribe(responseUser => {
          if (responseUser.Ok) {
            if (responseUser.Obj) {
              sessionStorage.setItem('UserId', responseUser.Obj.UserId.toString());
              sessionStorage.setItem('RightStatus', responseUser.Obj.RightStatus.toString());
              sessionStorage.setItem('LoginName', responseUser.Obj.LoginName);
              sessionStorage.setItem('Email', responseUser.Obj.Email);
              sessionStorage.setItem('Phone', responseUser.Obj.Phone);
              sessionStorage.setItem('FirstName', responseUser.Obj.FirstName);
              sessionStorage.setItem('LastName', responseUser.Obj.LastName);
              sessionStorage.setItem('Addresses', responseUser.Obj.Addresses);
              sessionStorage.setItem('Companies', responseUser.Obj.Companies);
              sessionStorage.setItem('FirstLogin', responseUser.Obj.FirstLogin ? 'true' : 'false');
              sessionStorage.setItem('TermsAndConditionRead', responseUser.Obj.TermsAndConditionRead ? 'true' : 'false');
              sessionStorage.setItem('MultiPartnerUser', responseUser.Obj.MultiPartnerUser ? 'true' : 'false');
              sessionStorage.setItem('ConfirmationMail', responseUser.Obj.ConfirmationMail ? 'true' : 'false');
              sessionStorage.setItem('ConfirmationMailAsked', responseUser.Obj.ConfirmationMailAsked ? 'true' : 'false');
              sessionStorage.setItem('SaturdayDelivery', responseUser.Obj.SaturdayDelivery ? 'true' : 'false');
              sessionStorage.setItem('WnExternal', responseUser.Obj.WnExternal ? 'true' : 'false');
              sessionStorage.setItem('WheelnewsSpecial', null);
              sessionStorage.setItem('ProcessIds', responseUser.Obj.ProcessIds ?? '');
              sessionStorage.setItem('OrderSource', responseUser.Obj.OrderSource ?? '');
              sessionStorage.setItem('Rights', '');
              sessionStorage.setItem('Modules', JSON.stringify(responseUser.Obj.Modules));
              if (responseUser.Obj.Rights.length !== 0) { sessionStorage.setItem('Rights', JSON.stringify(responseUser.Obj.Rights)); }
              if (responseUser.Obj.WnExternal) {
                sessionStorage.setItem('WheelnewsAddress', JSON.stringify(responseUser.Obj.WheelnewsAddress));
                sessionStorage.setItem('PrimaryAddress', null);
                sessionStorage.setItem('HomedeliveryAddress', null);
                this.nameChange.emit(responseUser.Obj.FirstName + ' ' + responseUser.Obj.LastName);
                this.router.navigate(['/home']).then(r => r);
              } else {
                if (responseUser.Obj.PrimaryAddressAid === 'OLYMSIONVW+NF') { responseUser.Obj.PrimaryAddressAid = 'OLYMSIONVWNF'; }
                this.addressService.getAddressByPartnerAid(responseUser.Obj.PrimaryAddressAid).subscribe(response => {
                  if (response.Ok) {
                    sessionStorage.setItem('WheelnewsAddress', null);
                    sessionStorage.setItem('PrimaryAddress', JSON.stringify(response.Obj));
                    this.nameChange.emit(responseUser.Obj.FirstName + ' ' + responseUser.Obj.LastName);
                    this.router.navigate(['/home']).then(r => r);
                    if (responseUser.Obj.HomeDeliveryPartnerAddressAid != null) {
                      if (responseUser.Obj.HomeDeliveryPartnerAddressAid != '') {
                        this.addressService.getAddressByPartnerAid(responseUser.Obj.HomeDeliveryPartnerAddressAid).subscribe(response2 => {
                          if (response2.Ok) {
                            sessionStorage.setItem('WheelnewsAddress', null);
                            sessionStorage.setItem('HomedeliveryAddress', JSON.stringify(response2.Obj));
                            this.nameChange.emit(responseUser.Obj.FirstName + ' ' + responseUser.Obj.LastName);
                            this.router.navigate(['/home']).then(r => r);
                            return;
                          } else if (response2.Msg === 'Internal Server Error') { console.log(response2.Ex); }
                          if (response2.Msg) { this.toast.fire({title: response2.Msg, icon: response2.Ok ? 'success' : 'error'}); }
                        }, error => { this.toast.fire(this.translation.InternalServerError); });
                      }
                    }
                    return;
                  } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
                  if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
                }, error => { this.toast.fire(this.translation.InternalServerError); });
              }
            }
          } else if (responseUser.Msg === 'Internal Server Error') { console.log(responseUser.Ex); }
          if (responseUser.Msg) { this.toast.fire({title: responseUser.Msg, icon: responseUser.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      }
    }, error => { this.toast.fire('Username or Password wrong.'); });
  }

  openContactForm(title: string) {
    this.newContactMessage.Title = title;
    this.newContactMessage.Email = '';
    this.newContactMessage.FirstName = '';
    this.newContactMessage.LastName = '';
    this.newContactMessage.Phone = '';
    this.newContactMessage.Company = '';
    this.newContactMessage.Street = '';
    this.newContactMessage.Zip = '';
    this.newContactMessage.City = '';
    this.newContactMessage.Message = '';
    this.newContactMessage.Type = 'LoginRequest';
    this.newContactMessage.Transport = false;
    this.newContactMessage.DamageReport = false;
    this.newContactMessage.WheelNews = false;
    this.newContactMessage.Fotobox = false;
    this.dialog.open(this.dialogTemplate);
  }

  send(){
    const mustBeFilled = ' ' + this.translation.MustBeFilled.charAt(0).toLowerCase() + this.translation.MustBeFilled.slice(1);
    if (this.newContactMessage.Title === '') { this.throwError(this.translation.Subject + mustBeFilled); return; }
    if (this.newContactMessage.Email === '') { this.throwError(this.translation.Email + mustBeFilled); return; }
    if (this.newContactMessage.FirstName === '') { this.throwError(this.translation.FirstName + mustBeFilled); return; }
    if (this.newContactMessage.LastName === '') { this.throwError(this.translation.LastName + mustBeFilled); return; }
    if (this.newContactMessage.Phone === '') { this.throwError(this.translation.Phone + mustBeFilled); return; }
    if (this.newContactMessage.Company === '') { this.throwError(this.translation.Company + mustBeFilled); return; }
    if (this.newContactMessage.Street === '') { this.throwError(this.translation.Street + mustBeFilled); return; }
    if (this.newContactMessage.Zip === '') { this.throwError(this.translation.Zip + mustBeFilled); return; }
    if (this.newContactMessage.City === '') { this.throwError(this.translation.City + mustBeFilled); return; }
    if (this.newContactMessage.Message === '') { this.throwError(this.translation.Message + mustBeFilled); return; }
    this.mailService.sendMail(this.newContactMessage).subscribe(response => {
      if (response.Ok) {
        Swal.fire({
          title: this.translation.MessageSentTitle,
          text: response.Ok && response.Obj ? this.translation.MessageSentText : response.Msg,
          confirmButtonColor: '#CC0000',
          confirmButtonText: 'OK',
          showConfirmButton: true,
          showCancelButton: false
        }).then (o => { this.dialog.closeAll(); });
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  cancel() {
    this.dialog.closeAll();
  }

  throwError(message: string) {
    Swal.fire({
      title: this.translation.Error,
      text: message,
      confirmButtonColor: '#CC0000',
      confirmButtonText: 'OK',
      showConfirmButton: true,
      showCancelButton: false
    });
  }

  changePassword(): void {
    this.userService.checkIfEmailExists(this.email).subscribe(responseExists => {
      if (responseExists.Ok) {
        if (responseExists.Obj) {
          this.changePasswordService.resetPasswordProcessPartOne(this.email).subscribe(response => {
            this.dialog.closeAll();
            if (response.Ok) {
              if (response.Obj) {
                Swal.fire(this.translation.Success, this.translation.ResetPasswordNotification1, 'success');
              }
            } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
            if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
          }, error => {
            this.dialog.closeAll();
            this.toast.fire(this.translation.InternalServerError); });
        } else {
          Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification3, 'error');
        }
      } else if (responseExists.Msg === 'Internal Server Error') { console.log(responseExists.Ex); }
      if (responseExists.Msg) { this.toast.fire({title: responseExists.Msg, icon: responseExists.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  openResetPasswordForm() {
    this.dialog.open(this.dialogPasswordTemplate);
  }
}
